export const REMOVE_BLOCK = "REMOVE_BLOCK"
export const REMOVE_BLOCK_SUCCESS = "REMOVE_BLOCK_SUCCESS"
export const REMOVE_BLOCK_CLEAN = "REMOVE_BLOCK_CLEAN"
export const REMOVE_BLOCK_ERROR = "REMOVE_BLOCK_ERROR"
